<template>
  <div>
    <Drawer ref="Drawer" />
    <CardWorkDetail ref="CardWorkDetail" />
    <CardWorkEdit ref="CardWorkEdit" />
    <CardWorkListConfirmUser ref="CardWorkListConfirmUser" />
    <CardBillDetail ref="CardBillDetail" />
    <CardPayOrderDetail ref="CardPayOrderDetail" />
    <CardParkSpaceUnPayOrderDetail ref="CardParkSpaceUnPayOrderDetail" />
    <CardWorkReturnVisitRecords ref="CardWorkReturnVisitRecords" />
    <CardWorkOrderReturnVisit ref="CardWorkOrderReturnVisit" />
  </div>
</template>

<script>
import Drawer from './components/Drawer'
import CardWorkDetail from './components/CardWorkDetail'
import CardWorkEdit from './components/CardWorkEdit'
import CardBillDetail from './components/CardBillDetail'
import CardWorkListConfirmUser from './components/CardWorkListConfirmUser'
import CardPayOrderDetail from './components/CardPayOrderDetail'
import CardParkSpaceUnPayOrderDetail from './components/CardParkSpaceUnPayOrderDetail'
import CardWorkOrderReturnVisit from './components/CardWorkOrderReturnVisit'
import CardWorkReturnVisitRecords from './components/CardWorkReturnVisitRecords'
import { getHouseholdByPhone } from '@/api/propertyManage'
import { buildingRoomDropList, worksheetCategoryDropList } from '@/api/dropList'

export default {
  components: {
    Drawer,
    CardWorkDetail,
    CardWorkEdit,
    CardWorkListConfirmUser,
    CardBillDetail,
    CardPayOrderDetail,
    CardParkSpaceUnPayOrderDetail,
    CardWorkReturnVisitRecords,
    CardWorkOrderReturnVisit,
  },
  provide() {
    return {
      indexThis: this,
    }
  },
  data() {
    return {
      housesList: [],
      // 当前项
      currentIndex: -1,
      housesIndex: 0,
      add: false,
      timer: '',
      userPhoneNumber: '',
      state: 1,
      worksheetCategoryListArr: [],
      dialogVisible: false,
      buildingRoomListArr: [],
    }
  },
  computed: {
    userId() {
      return this.$store.getters.staffId
    },
    housesInfo() {
      return this.housesList[this.housesIndex] || {}
    },
    communityId() {
      return this.housesInfo.communityId
    },
    buildingRoomId() {
      return this.housesInfo.buildingRoomId
    },
    householdPhone() {
      return this.housesInfo.householdPhone
    },
  },
  methods: {
    // 客服电话弹窗
    popupSetting(data) {
      if (!data) return
      if (data.onlineState === 2 && this.state === 1) {
        this.userPhoneNumber = data.userPhoneNumber
        this.householdList()
      }
      this.state = data.onlineState
    },

    async householdList() {
      const { data } = await getHouseholdByPhone({
        phone: this.userPhoneNumber,
      })
      this.housesList = data || []
      if (this.housesList.length === 1) this.housesIndex = 0
      this.$refs.Drawer.activeName = '1'
      this.$refs.Drawer.drawer = true
    },

    async buildingRoomList(params = {}) {
      const { data: res } = await buildingRoomDropList({ ...params })
      this.buildingRoomListArr = res || []
    },

    async worksheetCategoryList(params = {}) {
      this.worksheetCategoryListArr = []
      const { data: res } = await worksheetCategoryDropList({ ...params, worksheetType: 1 })
      if (!res.length) return (this.worksheetCategoryListArr = [])
      let children = [[], [], [], [], []]
      res.forEach(ele => {
        this.enumList.worksheetType.forEach(e => {
          if (ele.worksheetType === e.value)
            children[ele.worksheetType - 1].push({
              value: ele.worksheetCategoryId,
              label: ele.worksheetCategoryName,
            })
        })
        if (this.worksheetCategoryListArr.every(item => item.value !== ele.worksheetType)) {
          this.worksheetCategoryListArr.push({
            value: ele.worksheetType,
            label: this.dictType('worksheetType', ele.worksheetType),
            children: children[ele.worksheetType - 1],
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
